import { render, staticRenderFns } from "./CartFooterPickUp.vue?vue&type=template&id=1ddab814"
import script from "./CartFooterPickUp.vue?vue&type=script&lang=js"
export * from "./CartFooterPickUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports